import React, { useState } from "react";
import Bg from "./assets/background.svg";
import Logo from "./assets/logo.svg";
import Pad from "./assets/pad.svg";
import Facebook from "./assets/facebook.svg";
import Twitter from "./assets/twitter.svg";
import instagram from "./assets/instagram.svg";
import "./App.css";
import TextInput from "./Component/TextInput";
import Card from "./Component/Card";
import { DataBase } from "./FireBase";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [open, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [isLoading, setLoading] = useState(false);
  const handleCloseErrorCard = () => setError(false);

  const handleSubmit = () => {
    setLoading(true);

    if (!email) {
      toast.error("Enter email");
      return;
    }
    setEmail("");
    DataBase.ref("users")
      .push(email)
      .then((res) => {
        setLoading(false);
        toast("Successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => toast.error(error.message));
  };
  return (
    <div
      className="App"
      style={{
        background: `url(${Bg}) no-repeat `,
      }}
    >
      <div id="overlay">
        <ToastContainer />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 20,
          }}
        >
          <img src={Logo} />

          <p className="open">
            Wealth management should be{" "}
            <span style={{ color: "#FF6B35" }}>easy</span> and{" "}
            <span style={{ color: "#FF6B35" }}>accessible</span>
          </p>

          <p className="close">
            Let us help you run your own financial service practice. Sell an
            unlimited range of wealth management products and get instant
            commissions using Paystar!
          </p>
          <TextInput
            email={email}
            action={setEmail}
            submit={handleSubmit}
            load={isLoading}
          />

          {open && <Card close={handleCloseErrorCard} />}
          <div className="pad">
            <img src={Pad} className="padImage" />
          </div>
        </div>

        <div
          className="heightForPad"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-bewteen",
              zIndex: 10,
            }}
          >
            <a href="#" target="_blank" className="social">
              <img src={Facebook} width="15" height="15" />
            </a>

            <a className="social" href="#" target="_blank">
              <img src={Twitter} width="15" height="15" />
            </a>

            <a className="social" href="#" target="_blank">
              <img src={instagram} width="15" height="15" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
